import { ListPerson } from "../../List/schema/list";

/**
 * Decides whether a prospect should default to the Campaign tab (rather than Chat).
 *
 * A prospect "has a campaign" only when it is actually assigned to one (custom config,
 * campaignId, or addedToCampaignAt). A campaign that merely exists on the list (default
 * or otherwise) does NOT count — an unassigned lead opens the Chat tab.
 */
export const prospectHasCampaign = (prospect: ListPerson): boolean =>
	!!prospect.campaignConfig || !!prospect.campaignId || !!prospect.addedToCampaignAt;
